import React, { useEffect } from "react";
import { LanguageProvider } from "../contexts/LanguageContext";
import LoadingScreen from "./LoadingScreen";
import Particles from "./Particles";
import SpaceBackground from "./SpaceBackground";
import Header from "./Header";
import Home from "./Home";
import About from "./About";
import Skills from "./Skills";
import Projects from "./Projects";
import Certificates from "./Certificates";
import Footer from "./Footer";
import BackToTop from "./BackToTop";
import { visitorsApi } from "../services/api";

const Portfolio: React.FC = () => {
  useEffect(() => {
    visitorsApi.track({
      pageVisited: window.location.pathname,
      referer: document.referrer || null,
    }).catch(() => {});
  }, []);

  return (
    <LanguageProvider>
      <LoadingScreen />
      <Particles />
      <SpaceBackground />
      <Header />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Certificates />
      <Footer />
      <BackToTop />
    </LanguageProvider>
  );
};

export default Portfolio;
